/**
 * Returns true when an error originates from an AbortController cancellation.
 * Axios signals cancelled requests with code "ERR_CANCELED".
 *
 * Use this wherever in-flight request cancellation should be silently ignored
 * rather than treated as a real failure.
 */
export const isRequestCancelled = error => error?.code === "ERR_CANCELED";
